import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabsContent } from "components/ui/tabs";
import { StyledTabs } from "components/StyledTabs";
import { useProduct } from "contexts/ProductContext";

import { ImportDataTabContent } from "./components/ImportDataTabContent";
import { AcpTabContent } from "./components/AcpTabContent";

const RAW_DATA_SUB_TAB = {
  IMPORT: "import",
  ACP: "acp",
} as const;

type RawDataSubTab = (typeof RAW_DATA_SUB_TAB)[keyof typeof RAW_DATA_SUB_TAB];

export const RawDataTab = () => {
  const { t } = useTranslation(["productDetails"]);
  const { product } = useProduct();
  const [activeSubTab, setActiveSubTab] = useState<RawDataSubTab>(
    RAW_DATA_SUB_TAB.IMPORT,
  );

  if (!product) return null;

  const tabs = [
    {
      value: RAW_DATA_SUB_TAB.IMPORT,
      label: t("productDetails:rawData.importData.title"),
      testId: "raw-data-import-tab",
    },
    {
      value: RAW_DATA_SUB_TAB.ACP,
      label: t("productDetails:rawData.acp.title"),
      testId: "raw-data-acp-tab",
    },
  ];

  return (
    <StyledTabs
      activeTab={activeSubTab}
      onTabChange={setActiveSubTab}
      tabs={tabs}
      className="flex flex-col h-full"
    >
      <TabsContent
        value={RAW_DATA_SUB_TAB.IMPORT}
        className="flex-1 overflow-y-auto mt-2"
      >
        <ImportDataTabContent />
      </TabsContent>

      <TabsContent
        value={RAW_DATA_SUB_TAB.ACP}
        className="flex-1 overflow-y-auto mt-2"
      >
        <AcpTabContent />
      </TabsContent>
    </StyledTabs>
  );
};
